import styled from "styled-components";
export const Wrapper = styled.div `
  display: grid;
  margin: 1rem 0;
  grid-template-columns: 1fr;
  grid-auto-rows: minmax(288px, auto);
  grid-gap: 2rem;

  @media ${({ theme }) => theme.device.medium} {
    grid-template-columns: 1fr 6fr 1fr;
    grid-auto-rows: minmax(350px, auto);
    grid-gap: 2rem;
    margin: 1.5rem 0;
  }

  @media ${({ theme }) => theme.device.large} {
    width: 100%;
    grid-template-columns: 1fr 1fr;
    grid-auto-rows: minmax(500px, auto);
    grid-gap: 1.5rem;
  }

  @media ${({ theme }) => theme.device.xlarge} {
    width: 100%;
    grid-template-columns: 1fr 5fr 5fr 1fr;
    grid-gap: 1.5rem;
  }
`;
export const StyledSearchContainer = styled.div `
  margin: 2rem 0 3rem 0;
  display: flex;
  width: 100%;
  flex-direction: column;

  form {
    flex-grow: 1;
  }

  @media ${({ theme }) => theme.device.large} {
    flex-direction: row;
    margin: 2rem 0 1.5rem 0;
  }
`;
export const StyledContentWrapper = styled.div `
  display: flex;
  flex-direction: column;
  grid-column: 1;
  grid-row: 2;

  @media ${({ theme }) => theme.device.medium} {
    grid-column: 2;
    grid-row: 2;
  }

  @media ${({ theme }) => theme.device.large} {
    grid-column: 1;
    grid-row: 1;
  }

  @media ${({ theme }) => theme.device.xlarge} {
    grid-column: 2;
    grid-row: 1;
  }
`;
export const StyledMessage = styled.div `
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  ${({ isMultiLingual }) => (isMultiLingual ? `margin: 2rem 0 0 0` : "")};

  &&& h6 {
    margin: 0 0 0.5rem 0;
    font-weight: bold;
  }

  &&& p {
    margin: 0;
  }
`;
export const StyledTitleWrapper = styled.div `
  @media ${({ theme }) => theme.device.large} {
    margin-top: 3.75rem;
  }

  &&& h1 {
    margin: 0;
  }

  &&& span {
    display: block;
  }
`;
export const StyledGobackButton = styled.div `
  width: 16rem;
  margin: 2rem 0 1rem 0;

  @media ${({ theme }) => theme.device.medium} {
    margin: 2rem 0 1.5rem 0;
  }
`;
export const SytledImageWrapper = styled.div `
  grid-column: 1;
  grid-row: 1;

  @media ${({ theme }) => theme.device.medium} {
    grid-column: 2;
    grid-row: 1;
  }

  @media ${({ theme }) => theme.device.large} {
    grid-column: 2;
    grid-row: 1;
  }

  @media ${({ theme }) => theme.device.xlarge} {
    grid-column: 3;
    grid-row: 1;
  }

  display: flex;
  justify-content: center;
  align-items: center;

  && > div {
    min-height: 288px;

    @media ${({ theme }) => theme.device.medium} {
      max-height: 350px;
      max-width: 350px;
    }

    @media ${({ theme }) => theme.device.large} {
      max-height: 500px;
      max-width: 500px;
      margin-left: 0;
    }
  }
`;
export const LinksWrapper = styled.div `
  display: flex;
  flex-direction: column;
  flex-basis: auto;
  align-items: flex-start;
`;
